<script>
// @ts-check

export default {
  data: function() {
    return {}
  },
}
</script>

<template>
  <v-card style="min-width:320px">
    <v-card-text>
      <b>SAT/ACT Participation</b> - Participation and performance of graduating seniors from all Texas public schools on the College Board’s SAT and ACT, Inc.’s ACT assessment. Only one record is sent per student. If a student takes an ACT and/or SAT test more than once, the agency receives the record for the most recent examination taken.
    </v-card-text>
  </v-card>
</template>
